import spacetime from 'spacetime';

export default {
    //example: this.sharedActions.testeFunc();
    testeFunc() {
      console.log("testeeee worksssss");
    },
  
    // this.bluAmount = this.sharedActions.isNumberCheck(amount);
    isNumberCheck(amount) {
      let result;
      let amountFiltered;
      let amountFilteredArray = [];
      let firstDot = amount.indexOf(".");
      for (let i in amount) {
        if (
          ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."].includes(
            amount[i]
          )
        ) {
          if (amount[i] != ".") {
            amountFilteredArray.push(amount[i]);
          } else if (firstDot && i == firstDot && firstDot) {
            amountFilteredArray.push(amount[i]);
          }
        }
      }
      amountFiltered = amountFilteredArray.join("");
      result = amountFiltered;
  
      if (result == "." || !result) {
        result = "0";
      }
  
      return result;
    },
  
    formatSuffix(coinSymbol) {
      return " " + coinSymbol.toUpperCase();
    },
  
    currencyFormat(num) {
      return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
  
    validateAmount() {
      this.bluAmountValid = false;
      let indices = [];
      let amount = String(this.bluAmount);
  
      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }
      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }
  
      this.bluAmount = amount;
      this.isNumberCheck();
    },
  
    currencyFormat(num, fix) {
      if (num) {
        let fixed = num.toFixed(fix).replace(/[,.]/g, n => (n === "," ? "." : ","));
        return fixed.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
      } else {
        return 0;
      }
    },
  
    roundUp(num, precision) {
  
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },
  
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        this.callPurchasePreview();
        return true;
      }
    },

    formatDateTime(value){
      return spacetime(value).format('dd/MM/yyyy hh:mm:SS');
    },

    formatDateTimeHistory(value){
      return spacetime(value).format('yyyy-MM-ddTHH:mm:SS');
    }

  };


// WEBPACK FOOTER //
// ./src/utils/sharedActions/filters.js